import { Scale, Send, CheckCircle2, Clock, AlertTriangle, Database } from "lucide-react";

const StatCard = ({ icon: Icon, label, value, color, testid }) => (
  <div
    data-testid={testid}
    className="relative overflow-hidden rounded-lg border border-white/10 bg-[#111723] p-4 transition-colors duration-200 hover:border-white/20"
  >
    <div className="flex items-center justify-between">
      <span className="text-xs uppercase tracking-wider text-slate-400">{label}</span>
      <Icon className="h-4 w-4" style={{ color }} />
    </div>
    <div className="mt-3 font-mono-data text-3xl font-semibold text-slate-50" style={{ color }}>
      {value}
    </div>
  </div>
);

export const StatsBar = ({ stats }) => (
  <div className="grid grid-cols-2 gap-4 lg:grid-cols-5">
    <StatCard testid="stat-total" icon={Send} label="Total Requests" value={stats.total_requests ?? 0} color="#F1F5F9" />
    <StatCard testid="stat-replied" icon={CheckCircle2} label="Replied" value={stats.replied ?? 0} color="#10B981" />
    <StatCard testid="stat-pending" icon={Clock} label="Pending" value={stats.pending ?? 0} color="#F59E0B" />
    <StatCard testid="stat-notfound" icon={AlertTriangle} label="Not Found" value={stats.not_found ?? 0} color="#EF4444" />
    <StatCard testid="stat-cases" icon={Database} label="Case Records" value={stats.total_cases ?? 0} color="#2563EB" />
  </div>
);
